export const ORIGINATING_SYSTEMS = {
    Libra: 'libra',
    Taktikal: 'taktikal',
    CoreData: 'coredata',
};
